import React from "react";
import { func, bool, string, number } from "prop-types";
import { twMerge } from "tailwind-merge";

import ServiceTile from "./ServiceTile";
import ArrowDownIcon from "../../shared/Icons/ArrowDown";
import Typography from "../../shared/Typography";
import Icon from "@components/shared/Icons/Icon";

import { CUSTOMIZE_TYPES } from "@shared/constants";

const ClosedPackage = ({
  onClick,
  title,
  isSelected,
  backgroundUrl,
  singleItem,
  duration,
  type,
}) => {
  const isService = type === CUSTOMIZE_TYPES.SERVICE;

  return (
    <button
      data-id={`closed-package-${title}`}
      className={twMerge(
        "flex shrink-0 grow-0 basis-auto h-30 rounded-md uppercase whitespace-normal relative cursor-pointer",
        "bg-cover bg-no-repeat bg-right overflow-hidden",
        "transitions duration-150 active:scale-95",
        isSelected && "border-4 border-primaryOrange",
        singleItem ? "w-full h-39" : "w-30",
        isService ? "p-0" : "p-4"
      )}
      onClick={onClick}
      style={{ ...(backgroundUrl && { backgroundImage: backgroundUrl }) }}
    >
      {!isService && (
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/30 to-black/0 z-0" />
      )}
      {isService ? (
        <ServiceTile duration={duration} isOffset />
      ) : (
        <Typography
          className="text-white font-semibold relative z-1"
          data-id={`closed-package-${title}`}
        >
          {title}
        </Typography>
      )}
      <Icon
        className={twMerge(
          "grid place-items-center size-8 p-2 rounded-tl-md",
          "absolute right-0 bottom-0 shadow-sm shadow-primaryOrange/10",
          isSelected
            ? "bg-primaryOrange text-white"
            : "bg-white text-primaryOrange"
        )}
        icon={<ArrowDownIcon />}
      />
    </button>
  );
};

ClosedPackage.propTypes = {
  onClick: func.isRequired,
  title: string.isRequired,
  isSelected: bool.isRequired,
  backgroundUrl: string.isRequired,
  singleItem: bool,
  duration: number,
  type: string,
};

export default ClosedPackage;
